import { usePosts } from "./usePost";

//components
import { BreadCrumbs, Button } from "@atoms";
import { Input, Accordion, Select } from "@molecules";

export const PostsPage = () => {
  const helper = usePosts();

  if (helper.loading) {
    return <p>carregando...</p>;
  }

  if (!helper.loading && helper.postSearched && helper.showPost) {
    return (
      <>
        <BreadCrumbs items={["Postos", "Buscar", "Posto encontrado"]} />
        {helper.postSearched.map((item) => (
          <div>
            <Accordion Title={item?.razao ?? ""}>
              <div className="pb-[20px]">
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">CNPJ</span>
                  <span className="text-end max-w-[70%]">{item.cnpj}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Razão social</span>
                  <span className="text-end max-w-[70%]">{item.razao}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Telefone</span>
                  <span className="text-end max-w-[70%]">
                    {item.telefone === "" ? "Sem telefone cadastrado" : item.telefone}
                  </span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Credenciamento</span>
                  <span className="text-end max-w-[70%]">{item.credenciamento}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Inscrição Estadual</span>
                  <span className="text-end max-w-[70%]">{item.ie}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Código</span>
                  <span className="text-end max-w-[70%]">{item.codigo}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">E-mail</span>
                  <span className="text-end max-w-[70%]">{item.email ?? "-"}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Tipo</span>
                  <span className="text-end max-w-[70%]">{item.tipo_posto ?? "-"}</span>
                </p>

                <p className="my-[25px]">Linhas</p>
                {item.lines.length > 0 ? (
                  item.lines.map((line) => (
                    <p key={line.linha} className="w-full flex justify-between text-[14px]">
                      <span className="text-end max-w-[70%]">
                        {helper.getLineLabel(line.linha ?? "")}
                      </span>
                    </p>
                  ))
                ) : (
                  <p>Nenhuma linha localizada na telecontrol</p>
                )}

                <p className="my-[25px]">Dados de endereço</p>

                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Endereço</span>
                  <span className="text-end max-w-[70%]">{item.endereco ?? "-"}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Número</span>
                  <span className="text-end max-w-[70%]">{item.numero ?? "-"}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Complemento</span>
                  <span className="text-end max-w-[70%]">{item.complemento ?? "-"}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Bairro</span>
                  <span className="text-end max-w-[70%]">{item.bairro ?? "-"}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">CEP</span>
                  <span className="text-end max-w-[70%]">{item.cep ?? "-"}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Cidade</span>
                  <span className="text-end max-w-[70%]">{item.cidade ?? "-"}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Estado</span>
                  <span className="text-end max-w-[70%]">{item.estado ?? "-"}</span>
                </p>
              </div>
            </Accordion>
          </div>
        ))}
        <div className="w-full border-t border-[#D8DCDE] flex flex-col gap-[20px] mt-[10px] bg-white">
          <Button onClick={helper.backToSearch}>Voltar</Button>
        </div>
      </>
    );
  }

  return (
    <div>
      <BreadCrumbs items={["Postos", "Buscar"]} />
      <div
        className="w-full overflow-y-auto overflow-x-hidden
             -ms-overflow-style-none
             scrollbar-none"
      >
        <div className="w-[97%] ml-[5px] h-[90vh]">
          <div className="w-full flex justify-between items-center">
            <h3 className="text-[20px]">Filtros</h3>
            <Button onClick={helper.clean}>Limpar filtros</Button>
          </div>
          <Input
            label="CNPJ"
            type="string"
            placeholder="Informe o cnpj"
            onValueChange={(e) => {
              helper.handleCnpj(e);
            }}
            value={helper.cnpj}
          />
          <br />
          <div className="w-full flex justify-between gap-[15px]">
            <Select
              onChange={(e) => {
                helper.handleState(e.target.value);
              }}
              value={helper.state}
              label="Estado"
              options={[
                { value: "AC", label: "Acre" },
                { value: "AL", label: "Alagoas" },
                { value: "AP", label: "Amapá" },
                { value: "AM", label: "Amazonas" },
                { value: "BA", label: "Bahia" },
                { value: "CE", label: "Ceará" },
                { value: "DF", label: "Distrito Federal" },
                { value: "ES", label: "Espírito Santo" },
                { value: "GO", label: "Goiás" },
                { value: "MA", label: "Maranhão" },
                { value: "MT", label: "Mato Grosso" },
                { value: "MS", label: "Mato Grosso do Sul" },
                { value: "MG", label: "Minas Gerais" },
                { value: "PA", label: "Pará" },
                { value: "PB", label: "Paraíba" },
                { value: "PR", label: "Paraná" },
                { value: "PE", label: "Pernambuco" },
                { value: "PI", label: "Piauí" },
                { value: "RJ", label: "Rio de Janeiro" },
                { value: "RN", label: "Rio Grande do Norte" },
                { value: "RS", label: "Rio Grande do Sul" },
                { value: "RO", label: "Rondônia" },
                { value: "RR", label: "Roraima" },
                { value: "SC", label: "Santa Catarina" },
                { value: "SP", label: "São Paulo" },
                { value: "SE", label: "Sergipe" },
                { value: "TO", label: "Tocantins" },
              ]}
            />
            <Select
              label="Status"
              onChange={(e) => {
                helper.handleStatus(e.target.value);
              }}
              value={helper.status}
              options={[
                { value: "CREDENCIADO", label: "Credenciado" },
                { value: "DESCREDENCIADO", label: "Descredenciado" },
              ]}
            />
          </div>
          <br />
          <Input
            label="Cidade"
            type="string"
            placeholder="Informe a cidade"
            onValueChange={(e) => {
              helper.handleCity(e);
            }}
            value={helper.city}
          />
          <br />
          <div className="w-full flex justify-between gap-[12px]">
            <Input
              label="Nome"
              type="string"
              placeholder="Informe o nome"
              onValueChange={(e) => {
                helper.handleName(e);
              }}
              value={helper.name}
            />
            <Input
              label="Código"
              type="string"
              placeholder="Informe o código"
              onValueChange={(e) => {
                helper.handleCode(e);
              }}
              value={helper.code}
            />
          </div>
          <br />
          <Select
            label="Linha"
            onChange={(e) => {
              helper.handleLine(e.target.value);
            }}
            options={[
              { value: "ACE", label: "Acessórios" },
              { value: "AQC", label: "Aquecedor de gás;" },
              { value: "RAD", label: "Auto Rádio" },
              { value: "BRA", label: "Branca" },
              { value: "BRP", label: "Branca Premium" },
              { value: "COK", label: "Cooktop" },
              { value: "E/E", label: "Eletroeletrônicos" },
              { value: "ELE", label: "Eletro Portátil" },
              { value: "FER", label: "Ferramentas Elétricas" },
              { value: "INF", label: "Informática" },
              { value: "MQC", label: "Maquina de costura" },
              { value: "NTB", label: "Notebooks" },
              { value: "REFR", label: "Refrigeração" },
              { value: "SPL", label: "Split" },
              { value: "LCD", label: "Televisores e monitores" },
            ]}
            value={helper.line}
          />
          <br />
          <Select
            label="Tipo do posto"
            onChange={(e) => {
              helper.handleType(e.target.value);
            }}
            value={helper.type}
            options={[
              { value: "Distribuidor", label: "Distribuidor" },
              { value: "Instaladores", label: "Instaladores" },
              { value: "Posto", label: "Posto" },
              { value: "Posto Interno - Sem", label: "Posto Interno - Sem" },
              { value: "pedido", label: "Pedido" },
              { value: "Posto atende revenda", label: "Posto atende revenda" },
              { value: "única", label: "Única" },
              { value: "eletro", label: "Eletro" },
            ]}
          />
        </div>
      </div>
      <div className="w-full border-t border-[#D8DCDE] flex flex-col gap-[20px] mt-[10px] bg-white">
        <Button onClick={helper.handleSearch}>Buscar Posto</Button>
        <Button onClick={helper.backToHome}>Voltar</Button>
      </div>
    </div>
  );
};
